import { parsePropertyIds, getAllFilterItems } from '~/utils/plp';
import { clearPlpFilters, hasPlpFilters, propertyLabel } from '~/utils/plpNavigation';

export function usePlpFilters(stableFilters: Ref<any[]>) {
    const keepFilters = useKeepFilters();
    const route = useRoute();
    const router = useRouter();

    const activePropertyIds = computed(() => parsePropertyIds(route.query.properties));

    const removePropertyFilter = (id: string) => {
        const criteria = activePropertyIds.value.filter(pid => pid !== id);
        router.push({
            path: route.path,
            query: { ...route.query, ...(keepFilters.value ? { p: undefined } : {}), properties: criteria.join('|') || undefined },
        });
    };

    const clearPriceFilter = () => {
        const query = { ...route.query };
        delete query['min-price'];
        delete query['max-price'];
        if (keepFilters.value) delete query.p;
        router.push({ path: route.path, query });
    };

    const clearAllFilters = () => {
        router.push({ path: route.path, query: keepFilters.value ? clearPlpFilters(route.query) : { tn_q: route.query.tn_q, tn_cid: route.query.tn_cid, sort: route.query.sort } });
    };

    const activeFilterNames = computed(() => {
        const map = new Map<string, string>(keepFilters.value ? activePropertyIds.value.map(id => [id, propertyLabel(id)]) : []);
        const filters = stableFilters.value;
        if (!filters) return map;

        for (const filter of filters) {
            const allItems = getAllFilterItems(filter);
            for (const item of allItems) {
                if (!item.id || !item.translated?.name) continue;
                if (activePropertyIds.value.includes(item.id)) {
                    map.set(item.id, item.translated.name);
                }
            }
        }
        return map;
    });

    const hasActiveFilters = computed(() => hasPlpFilters(route.query));

    return {
        hasActiveFilters,
        activePropertyIds,
        activeFilterNames,
        removePropertyFilter,
        clearPriceFilter,
        clearAllFilters,
    };
}
